module.exports = __webpack_public_path__ + "media/customize/banner-push-bottom-d3410a1d.svg";